<cap-bsg-alert *ngFor="let alert of alerts" [type]="alert.type" (dismiss)="dismiss(alert)">
  <span [innerHtml]="alert.message"></span>
  <ng-container *ngIf="alert.type === capAlertTypeDanger">
    <button (click)="copyStackToClipboard(alert)" class="alert-danger, alert-button">Copy Details</button>
    <button (click)="reportError(alert)" class="alert-button">Report</button>
  </ng-container>
</cap-bsg-alert>
